enum TenantUnavailableTestIds {
    TENANT_SENEC_UNAVAILABLE = 'tenantSenecUnavailableDialog',
    TENANT_SENEC_UNAVAILABLE_OPEN_PORTAL = 'tenantSenecUnavailableOpenPortal',
    TENANT_SENEC_UNAVAILABLE_LOGOUT = 'tenantSenecUnavailableLogout',
}

export default TenantUnavailableTestIds
